<div class="h-[18rem] overflow-y-scroll overflow-x-hidden use-scrollbar">
  @for (message of messages; track message; let isLast = $last) {
    <app-special-message-pop-up-preview
      [message]="message"
      [isLast]="isLast"
      (pickMessage)="onItemClicked.emit(message)"
      />
  }
</div>